import React from 'react'
import Carrousel from '../carrousel'

function Slider() {
  return (
    <div className='flex'id="slider">
      <Carrousel/>
    </div>
  )
}

export default Slider